// extracted by mini-css-extract-plugin
module.exports = {"container":"Vehicle_container__o8A2F","page":"Vehicle_page__L2cC-","section":"Vehicle_section__1fpeF"};